module.exports = __webpack_public_path__ + "img/24.fca0455e.jpg";